import React, { useState } from 'react';

const FONT = '"Nunito", "Baloo 2", sans-serif';

/** G1: Show word + image → student self-reports "know" or "don't know" */
export default function FlashcardAssess({ roundData, onAnswer, palette: P, disabled }) {
  const [flipped, setFlipped] = useState(false);
  const [answered, setAnswered] = useState(false);
  const prompt = roundData.prompt || {};
  const reveal = roundData.reveal || {};

  const handleFlip = () => {
    if (disabled || flipped || answered) return;
    setFlipped(true);
  };

  const handleAnswer = (knows) => {
    if (disabled || answered) return;
    setAnswered(true);
    setTimeout(() => onAnswer(knows, knows ? 'know' : 'dont_know'), 600);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20, width: '100%', maxWidth: 400, margin: '0 auto', fontFamily: FONT }}>
      <div style={{ fontSize: 16, fontWeight: 700, color: P.mutedText }}>
        Bạn biết từ này không?
      </div>

      {/* Card */}
      <div onClick={handleFlip} style={{
        width: '100%', minHeight: 200, borderRadius: 20,
        border: `3px solid ${P.ink}`, boxShadow: `0 6px 0 ${P.ink}`,
        background: flipped ? '#FFF9E6' : '#fff',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        padding: 24, cursor: (disabled || flipped) ? 'default' : 'pointer', transition: 'all 0.3s',
        opacity: disabled ? 0.6 : 1,
      }}>
        {prompt.image_url && (
          <img src={prompt.image_url} alt="" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 12, marginBottom: 12 }} />
        )}
        <div style={{ fontSize: 28, fontWeight: 800, color: P.ink }}>{prompt.word}</div>
        {prompt.pronunciation_uk && (
          <div style={{ fontSize: 14, color: P.mutedText, marginTop: 4 }}>{prompt.pronunciation_uk}</div>
        )}
        {!flipped && (
          <div style={{ fontSize: 13, color: P.mutedText, marginTop: 12 }}>Chạm để xem nghĩa</div>
        )}
        {flipped && (
          <div style={{ marginTop: 16, textAlign: 'center' }}>
            <div style={{ fontSize: 20, fontWeight: 700, color: P.coral }}>{reveal.name_vi}</div>
            {reveal.definition_en && (
              <div style={{ fontSize: 14, color: P.mutedText, marginTop: 6 }}>{reveal.definition_en}</div>
            )}
          </div>
        )}
      </div>

      {/* Know / Don't know buttons */}
      {flipped && !answered && !disabled && (
        <div style={{ display: 'flex', gap: 16, width: '100%' }}>
          <button onClick={() => handleAnswer(false)} style={{
            flex: 1, padding: '14px 0', borderRadius: 14,
            border: `2.5px solid #E74C3C`, boxShadow: '0 4px 0 #C0392B',
            background: '#FFD6D6', color: '#E74C3C',
            fontSize: 16, fontWeight: 800, cursor: 'pointer', fontFamily: FONT,
          }}>
            Chưa biết
          </button>
          <button onClick={() => handleAnswer(true)} style={{
            flex: 1, padding: '14px 0', borderRadius: 14,
            border: `2.5px solid #2ECC71`, boxShadow: '0 4px 0 #27AE60',
            background: '#D4F5E0', color: '#2ECC71',
            fontSize: 16, fontWeight: 800, cursor: 'pointer', fontFamily: FONT,
          }}>
            Biết rồi!
          </button>
        </div>
      )}
    </div>
  );
}
